import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController, NavController, AlertController, ToastController, LoadingController } from '@ionic/angular';

import { BasePage } from '../../base.page';
import { ConfiguracoesModel } from 'projects/core/src/lib/core/model/ConfiguracoesModel';
import { ConfiguracoesViewModel } from './ConfiguracoesViewModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';

@Component({
  selector: 'configuracoes-page',
  templateUrl: 'configuracoes.page.html',
  styleUrls: ['configuracoes.page.scss']
})
export class ConfiguracoesPage extends BasePage {
  constructor(
    private menuCtrl: MenuController, 
    public router: Router,
    public navCtrl: NavController,
    public alertController: AlertController,
    public loadingController: LoadingController,
    public toastCtrl: ToastController) {
      super(router)
  }

  loadingComponent: LoadingComponent
  configuracoesViewModel: ConfiguracoesViewModel
  configuracoesModel: ConfiguracoesModel
  alertComponent: AlertComponent
  emRequisicao: Boolean = true

  ngOnInit() {
    this.inicializarVariaveis()
  }

  inicializarVariaveis() {
    this.configuracoesModel = new ConfiguracoesModel()
    this.configuracoesViewModel = new ConfiguracoesViewModel()
    this.configuracoesViewModel.setContext(this)
    this.loadingComponent = new LoadingComponent(this.loadingController)
  }

  async enviaOpcaoImpressaoDigital() {
    try {
      this.emRequisicao = true
      await this.configuracoesViewModel.enviaOpcaoImpressaoDigital(this.configuracoesModel.impressaoDigital)
    } catch(e) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
      this.toggleImpressaoDigital()
    }
    setTimeout(() => {
      this.emRequisicao = false
    }, 1000)
  }

  async enviaOpcaoReconhecimentoFacial() {
    try {
      this.emRequisicao = true
      await this.configuracoesViewModel.enviaOpcaoReconhecimentoFacial(this.configuracoesModel.reconhecimentoFacial)
    } catch(e) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
      this.toggleReconhecimentoFacial()
    }
    setTimeout(() => {
      this.emRequisicao = false
    }, 1000)
  }

  mensagemSucessoAlteracao(message: string) {
    this.showToast(message)
  }

  mensagemFalhaAlteracao(message: string) {
    this.showToast(message)
  }

  async showToast(message: string) {
    let toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  toggleImpressaoDigital() {
    this.configuracoesModel.impressaoDigital = !this.configuracoesModel.impressaoDigital
  }

  toggleReconhecimentoFacial() {
    this.configuracoesModel.reconhecimentoFacial = !this.configuracoesModel.reconhecimentoFacial
  }

  btnImpressaoDigital() {
    this.toggleImpressaoDigital()
    this.enviaOpcaoImpressaoDigital()
  }

  btnReconhecimentoFacial() {
    this.toggleReconhecimentoFacial()
    this.enviaOpcaoReconhecimentoFacial()
  }

  btnPaginaNotificacoes() {
    this.openPage('navigation/configuracoes/notificacoes')
  }

   btnPaginaTrocarSenha() {
    this.openPage('navigation/configuracoes/trocar-senha')
  }

  backPage() {
    this.navCtrl.back();
  }

  btnExcluirConta() {
    AlertComponent.showAlert("Atenção", "Você está prestes à excluir sua conta PhiCube. Tem certeza que deseja continuar?", null, [
      {
          text: 'Sim',
          role: 'yes',
          handler: () => {
            this.handlerRemoveAccount()
          }
      },
      {
          text: 'Não',
          role: 'cancel',
          handler: () => {
              
          }
      }
    ])
  }

  async showLoading() {
    return await this.loadingComponent.showLoading()
  }

  async handlerRemoveAccount() {
    debugger
    const loadingGeral = await this.showLoading()
    try {
      const result = await this.configuracoesViewModel.removeConta()
      if (result.status == ResponseModel.STATUS_NO_CONTENT) {
        AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, "Conta excluída com sucesso!")
        AppSession.clearSession()
        this.openPage('login')
      } else {
        throw Error()
      }
    } catch(e) {
      AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
    }
    loadingGeral.dismiss()
  }
}
